import NotificationListPage from "@/components/notifications/NotificationListPage"

const AdminNotification = () => (
    <NotificationListPage
        title="Thông báo hệ thống"
        scope="admin"
        maxWidthClass="max-w-6xl"
    />
)

export default AdminNotification
